import React, { Component } from 'react';
import { Route } from 'react-router';
import '@progress/kendo-theme-material/dist/all.css';
import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { Residential } from './components/Residential';
import { ListingDetail } from './components/ListingDetail';
import { FeaturedListings } from './components/FeaturedListings';
import { LandListings } from './components/LandListings';
import { Videos} from './components/Videos';
import { Search} from './components/Search';
import { SendEmail} from './components/SendEmail';
import { AboutUs} from './components/AboutUs';

export default class App extends Component {

  render () {
    return (
      <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/search' component={Search} />
        <Route path='/residential' component={Residential} />
        <Route path='/property/:id' component={ListingDetail} />
        <Route path='/land' component={LandListings} />
        <Route path='/listings' component={FeaturedListings} />
        <Route path='/videos' component={Videos} />
        <Route path='/aboutus' component={AboutUs} />
        <Route path='/email' component={SendEmail} />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js